/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React, { useEffect, useState } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { Box } from 'grommet';

import { DisablednessProvider } from 'blb-contexts/Disabledness';
import { MeContext } from 'blb-contexts/Me';
import { getPersona } from 'blb-persona/index';

import { getRouteConfigurations } from './routeConfiguration';
import { MainPaneContainer } from './MainPaneContainer';
import { SidebarContainer } from './SidebarContainer';
import { InactivityTimer } from './InactivityTimer';
import { ToastProvider } from './Toast';
import { CenteredLoadingSpinner } from 'blb-components/CenteredLoadingSpinner';
export namespace AuthenticatedApp {
  export interface Props {
    me: MeContext;
  }
}

export const AuthenticatedApp: React.FC<AuthenticatedApp.Props> = ({ me }) => {
  const [landingRoute, setLandingRoute] = useState<string>();
  const persona = getPersona(me!.principalType);

  useEffect(() => {
    setLandingRoute(persona.getAllowedRoutes(me!).defaultLandingPath);
  }, []);

  if (!landingRoute) return <CenteredLoadingSpinner />;

  const getRoutesMap = () => {
    const routesMap = getRouteConfigurations(persona.getAllowedRoutes(me!).allowedRoutes);
    return (
      <Switch>
        <Route exact path={routesMap.map(route => route.path)}>
          <Box direction="row" flex>
            <SidebarContainer />
            <MainPaneContainer routes={routesMap} />
          </Box>
        </Route>
        <Redirect from="*" to={landingRoute} />
      </Switch>
    );
  };

  return (
    <MeContext.Provider value={me}>
      <ToastProvider>
        <DisablednessProvider>
          <InactivityTimer />
          {getRoutesMap()}
        </DisablednessProvider>
      </ToastProvider>
    </MeContext.Provider>
  );
};
